/* OWR PDP behaviors — evemen-style UX on Dawn
   1. SELECT SIZE gating: ATC reads "SELECT SIZE" until a size is picked;
      tapping it nudges the size grid instead of adding.
   2. Accordions (one-open-at-a-time, animated).
   3. Size chart bottom-sheet (builds table from majime_size_chart JSON).
   4. Sticky bottom card: slides up when related-products enters viewport.
*/
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* =====================================================
     1. SELECT SIZE gating
     ===================================================== */
  function sizeFieldset() {
    // the pill fieldset whose legend/label mentions "size"
    var sets = qsa('variant-selects fieldset.product-form__input--pill, variant-selects .product-form__input--pill');
    if (!sets.length) return null;
    var byName = sets.find(function (fs) {
      var lbl = fs.querySelector('legend, .form__label');
      return lbl && /size/i.test(lbl.textContent);
    });
    return byName || sets[0];
  }

  function sizeChosen() {
    var fs = sizeFieldset();
    if (!fs) return true; // no size option → never gate
    var checked = fs.querySelector('input:checked');
    return !!(checked && checked.dataset.owrUserPicked === '1');
  }

  function atcButtons() {
    return qsa('.product-form__submit');
  }

  function setAtcLabel() {
    atcButtons().forEach(function (btn) {
      var span = btn.querySelector('span') || btn;
      if (!btn.dataset.owrAddLabel) {
        btn.dataset.owrAddLabel = (span.textContent || 'Add to cart').trim();
      }
      if (!sizeChosen()) {
        span.textContent = 'Select Size';
        btn.classList.add('owr-needs-size');
      } else {
        span.textContent = btn.dataset.owrAddLabel;
        btn.classList.remove('owr-needs-size');
      }
      var sticky = qs('.owr-sticky-atc__btn');
      if (sticky) sticky.textContent = sizeChosen() ? 'Add to cart' : 'Select Size';
    });
  }

  function initSizeGate() {
    var fs = sizeFieldset();
    if (!fs) return;
    // Dawn preselects the first variant; treat it as "not user-picked".
    fs.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input')) {
        e.target.dataset.owrUserPicked = '1';
        setAtcLabel();
      }
    });
    setAtcLabel();

    atcButtons().forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!sizeChosen()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var grid = sizeFieldset();
          if (grid) {
            grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            grid.classList.remove('owr-nudge');
            void grid.offsetWidth; // restart animation
            grid.classList.add('owr-nudge');
          }
        }
      }, true); // capture: run before Dawn's product-form handler
    });
  }

  /* =====================================================
     2. Accordions
     ===================================================== */
  window.owrAccToggle = function (btn) {
    var item = btn.closest('.owr-acc-item');
    if (!item) return;
    var wasOpen = item.classList.contains('open');
    var root = item.closest('.owr-acc');
    qsa('.owr-acc-item.open', root).forEach(function (el) {
      el.classList.remove('open');
      var t = el.querySelector('.owr-acc-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  function initSpecs() {
    var el = qs('#owr-spec-data');
    var mount = qs('#owr-spec-list');
    if (!el || !mount) return;
    var specs;
    try { specs = JSON.parse(el.textContent.trim()); } catch (e) { return; }
    var order = [['fit', 'Fit'], ['composition', 'Composition'], ['technique', 'Technique'], ['fabric', 'Fabric']];
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    var html = '';
    order.forEach(function (pair) {
      var val = specs && specs[pair[0]] != null ? String(specs[pair[0]]).trim() : '';
      if (!val) return;
      html += '<li><span class="owr-spec-label">' + pair[1] + ':</span>' + esc(val) + '</li>';
    });
    if (!html) {
      var item = mount.closest('.owr-acc-item');
      if (item) item.style.display = 'none';
      return;
    }
    mount.innerHTML = html;
  }

  /* =====================================================
     3. Size chart drawer
     ===================================================== */
  function owrSortSizes(rows) {
    var order = { xxxs: 0, xxs: 1, xs: 2, s: 3, m: 4, l: 5, xl: 6, xxl: 7, '2xl': 7, xxxl: 8, '3xl': 8, xxxxl: 9, '4xl': 9 };
    function rank(label) {
      var s = String(label).trim().toLowerCase();
      if (s !== '' && !isNaN(Number(s))) return { group: 0, value: Number(s) };
      if (order[s] !== undefined) return { group: 1, value: order[s] };
      return { group: 2, value: 0 };
    }
    return rows
      .map(function (label, i) { return { label: label, i: i, r: rank(label) }; })
      .sort(function (a, b) {
        if (a.r.group !== b.r.group) return a.r.group - b.r.group;
        if (a.r.value !== b.r.value) return a.r.value - b.r.value;
        return a.i - b.i;
      })
      .map(function (x) { return x.label; });
  }

  function buildSizeChart() {
    var el = qs('#owr-size-chart-data');
    var mount = qs('#owr-size-chart-table');
    if (!el || !mount || mount.dataset.built) return;
    var chart;
    try { chart = JSON.parse(el.textContent.trim()); }
    catch (e) { mount.innerHTML = '<p style="opacity:.6">Size chart unavailable.</p>'; return; }
    var rows = owrSortSizes(chart.rows || []);
    var cols = chart.columns || [];
    var vals = chart.values || {};
    var html = '<table class="owr-sc-table"><thead><tr><th>Size</th>';
    cols.forEach(function (c) { html += '<th>' + (c.label || '') + '</th>'; });
    html += '</tr></thead><tbody>';
    rows.forEach(function (r) {
      html += '<tr><th>' + r + '</th>';
      cols.forEach(function (c) {
        var v = (vals[r] && vals[r][c.key] != null) ? vals[r][c.key] : '';
        var num = parseFloat(v);
        html += isNaN(num) ? '<td>' + v + '</td>' : '<td data-inch="' + num + '">' + v + '</td>';
      });
      html += '</tr>';
    });
    html += '</tbody></table>';
    mount.innerHTML = html;
    mount.dataset.built = '1';
  }

  window.owrOpenSizeChart = function () {
    buildSizeChart();
    var d = qs('#owr-size-chart-drawer');
    if (d) d.classList.add('active');
  };
  window.owrForceCloseSizeChart = function () {
    var d = qs('#owr-size-chart-drawer');
    if (d) d.classList.remove('active');
  };
  window.owrCloseSizeChart = function (e) {
    if (e.target && e.target.id === 'owr-size-chart-drawer') window.owrForceCloseSizeChart();
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.owrForceCloseSizeChart();
  });

  /* =====================================================
     4. Sticky bottom card
     ===================================================== */
  function initStickyAtc() {
    var bar = qs('.owr-sticky-atc');
    var trigger = qs('.related-products') || qs('.product__info-container');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('visible', entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(trigger);

    var btn = qs('.owr-sticky-atc__btn');
    if (btn) {
      // Mirror the real ATC button: it is the single source of truth for
      // label ("Add to cart" / "Sold out" / "Unavailable") and disabled state.
      // Dawn replaces this element wholesale on variant change, so re-query
      // it every time rather than holding a reference.
      function syncSticky() {
        var main = qs('.product-form__submit');
        var label = btn.querySelector('.owr-sticky-atc__btn-text');
        if (!main || !label) return;
        var mainLabel = main.querySelector('span');
        label.textContent = (mainLabel ? mainLabel.textContent : main.textContent).trim();
        btn.disabled = main.disabled;
        btn.setAttribute('aria-disabled', main.disabled ? 'true' : 'false');
        if (main.disabled) btn.classList.remove('loading');
      }

      var syncTimer;
      function queueSync() {
        clearTimeout(syncTimer);
        syncTimer = setTimeout(syncSticky, 60);
      }

      syncSticky();

      // The whole product-info block is re-rendered on variant change, so watch
      // the container rather than the button itself.
      var infoBlock = qs('.product__info-container') || qs('.product');
      if (infoBlock && 'MutationObserver' in window) {
        new MutationObserver(queueSync).observe(infoBlock, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'class']
        });
      }

      if ('PUB_SUB_EVENTS' in window && window.subscribe) {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, queueSync);
      }

      btn.addEventListener('click', function () {
        var main = qs('.product-form__submit');
        if (!main || main.disabled) return;
        btn.classList.add('loading');
        main.click();
      });

      // clear the sticky spinner once the cart updates (drawer opens / cart re-renders)
      if ('PUB_SUB_EVENTS' in window && window.subscribe) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          btn.classList.remove('loading');
        });
      } else {
        // fallback: clear when the main button leaves its loading state
        var main = qs('.product-form__submit');
        if (main) {
          new MutationObserver(function () {
            if (!main.classList.contains('loading')) btn.classList.remove('loading');
          }).observe(main, { attributes: true, attributeFilter: ['class'] });
        }
      }
    }
  }

  /* ---------- boot ---------- */
  function init() {
    // initSizeGate();
    initSpecs();
    initStickyAtc();
    // re-run label sync after Dawn swaps variant markup (section re-render)
    // document.addEventListener('change', function (e) {
    //   if (e.target && e.target.closest && e.target.closest('variant-selects')) {
    //     setTimeout(setAtcLabel, 150);
    //   }
    // });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =====================================================
   5. Live size line — "Size: X / Chest: Y Inch / ..."
   ===================================================== */
(function () {
  'use strict';
  function qs(s, r) { return (r || document).querySelector(s); }

  function chartData() {
    var el = qs('#owr-size-chart-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return null; }
  }

  function updateLiveSize() {
    var line = qs('#OwrLiveSize');
    var chart = chartData();
    if (!line || !chart) return;
    var fs = document.querySelector('variant-selects fieldset.product-form__input--pill');
    var checked = fs && fs.querySelector('input:checked');
    if (!checked || checked.dataset.owrUserPicked !== '1') { line.hidden = true; return; }
    var size = checked.value;
    var vals = (chart.values && chart.values[size]) || null;
    if (!vals) { line.hidden = true; return; }
    var parts = ['<strong>Size:</strong> ' + size];
    (chart.columns || []).slice(0, 2).forEach(function (c) {
      if (vals[c.key] != null && vals[c.key] !== '') {
        parts.push('<strong>' + c.label + ':</strong> ' + vals[c.key] + ' Inch');
      }
    });
    line.innerHTML = parts.join(' <span class="owr-live-sep">/</span> ');
    line.hidden = false;
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) {
      setTimeout(updateLiveSize, 120);
    }
  });
  document.addEventListener('DOMContentLoaded', updateLiveSize);
})();

/* =====================================================
   6. Flip text rotator under ATC
   ===================================================== */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.getElementById('OwrFlipText');
    if (!wrap) return;
    var spans = Array.prototype.slice.call(wrap.querySelectorAll('span'));
    if (spans.length < 2) return;
    var i = 0;
    setInterval(function () {
      spans[i].classList.remove('active');
      i = (i + 1) % spans.length;
      spans[i].classList.add('active');
    }, 2800);
  });
})();

/* =====================================================
   7. Size chart Inch/Cm tabs
   ===================================================== */
(function () {
  'use strict';
  window.owrSizeChartUnit = function (btn, unit) {
    var head = btn.closest('.owr-size-chart-panel');
    if (!head) return;
    head.querySelectorAll('.owr-sc-tab').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    head.querySelectorAll('.owr-sc-table td[data-inch]').forEach(function (td) {
      var v = parseFloat(td.dataset.inch);
      if (isNaN(v)) return;
      td.textContent = unit === 'cm' ? (Math.round(v * 2.54 * 10) / 10) : v;
    });
    var note = head.querySelector('.owr-size-chart-unit');
    if (note) note.textContent = unit === 'cm' ? 'All values in cm' : 'All values in inches';
  };
})();

/* =====================================================
   8. Buy-it-now mirrors the Add-to-Cart disabled state
   ===================================================== */
(function () {
  'use strict';
  var mo;
  function sync() {
    var atc = document.querySelector('.product-form__submit:not(.owr-buy-now)');
    var buy = document.querySelector('.owr-buy-now');
    if (!atc || !buy) return;
    if (buy.disabled === atc.disabled) return; // no change → don't touch the DOM
    if (mo) mo.disconnect();                    // pause observer while we write
    buy.disabled = atc.disabled;
    if (mo) start();                            // resume
  }
  function start() {
    var form = document.querySelector('product-form') || document.body;
    mo.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
  }
  document.addEventListener('DOMContentLoaded', function () {
    mo = new MutationObserver(sync);
    start();
    sync();
  });
})();